import React from 'react';
import { HStack, StackProps } from '@adc/parallax-component-library';
import { ChildrenPlacement } from './DynamicTable';
import { TableFilters } from './TableFilters';
import { TableSelectionActions } from './TableSelectionActions';

interface TableToolbarProps {
  children?: React.ReactElement;
  childrenPlacement: ChildrenPlacement;
  toolbarProps?: Partial<StackProps>;
  // Filter props
  enableFiltering: boolean;
  checkboxFilters: any[];
  isFilterPopupOpen: boolean;
  setIsFilterPopupOpen: (open: boolean) => void;
  activeFiltersCount: number;
  onFilterChange: (sectionId: any, item: any) => void;
  onResetFilters: () => void;
  // Selection props
  enableSelection: boolean;
  isEveryVisibleRowSelected: boolean;
  onBatchSelectButtonPress: () => void;
  rowDataLength: number;
  selectionActions?: React.ReactNode;
  enableSelectAll?: boolean;
}

export const TableToolbar: React.FC<TableToolbarProps> = ({
  children,
  childrenPlacement,
  toolbarProps,
  enableFiltering,
  checkboxFilters,
  isFilterPopupOpen,
  setIsFilterPopupOpen,
  activeFiltersCount,
  onFilterChange,
  onResetFilters,
  enableSelection,
  isEveryVisibleRowSelected,
  onBatchSelectButtonPress,
  rowDataLength,
  selectionActions,
  enableSelectAll = true,
}) => {
  const defaultToolbarProps: Partial<StackProps> = {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    gap: '$2',
  };

  return (
    <HStack {...defaultToolbarProps} {...toolbarProps}>
      {children && childrenPlacement === 'start' ? children : null}
      <HStack gap="$2" alignItems="flex-end">
        <TableFilters
          enableFiltering={enableFiltering}
          checkboxFilters={checkboxFilters}
          isFilterPopupOpen={isFilterPopupOpen}
          setIsFilterPopupOpen={setIsFilterPopupOpen}
          activeFiltersCount={activeFiltersCount}
          onFilterChange={onFilterChange}
          onResetFilters={onResetFilters}
        />
        <TableSelectionActions
          enableSelection={enableSelection && enableSelectAll}
          isEveryVisibleRowSelected={isEveryVisibleRowSelected}
          onBatchSelectButtonPress={onBatchSelectButtonPress}
          rowDataLength={rowDataLength}
          selectionActions={selectionActions}
        />
      </HStack>
      {children && childrenPlacement === 'end' ? children : null}
    </HStack>
  );
};
